export enum CHART_OF_ACCOUNTS_DEFAULT_FIELDS {
  STATEMENTS = 'Statements',
  LEDGER_CATEGORY = 'Ledger Categories',
  LEDGER_TYPE = 'Ledger Types',
}
